import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { HomeOutlined } from '@ant-design/icons';

// DS
import { Col, VertTypography, VertIcon } from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Checkout/CheckoutDeliveryAddressStyles.less';

// UTILS
import ModalNewDeliveryAddress from 'components/Modal/ModalNewDeliveryAddress';
import DeliveryAddressInfos from '../DeliveryAddressInfos/DeliveryAddressInfos';
import { useSelector } from 'react-redux';
import ynToBool from 'Utils/ynToBool';
import { handleObjectAddress } from 'Utils/handleObjectAddress';
import AlertAddress from 'components/AlertAddress/AlertAddress';

const addressClear = {
  contact: '',
  name: '',
  street: '',
  number: '',
  bourgh: '',
  city: '',
  state: '',
  uf: '',
  cep: '',
  complement: '',
  reference: '',
};

// CHECKOUT PERSONAL DATA COMPONENT
const CheckoutDeliveryAddress = ({ addressInvalid, ...props }) => {
  const [openModal, setOpenModal] = useState(false);
  const [editAdress, setEditAdress] = useState({ ...addressClear });

  const [combinedAddress, setCombinedAddress] = useState({});

  const Participants = useSelector(({ Participants: data }) => data);
  const Cart = useSelector(({ Cart: data }) => data);

  useEffect(() => {
    if (Cart?.cartFinishRequests && Participants?.finishRequests) {
      const result = handleObjectAddress(Cart, Participants);

      setCombinedAddress(result);
    }
  }, [Cart?.cartFinishRequests, Participants?.finishRequests]);

  return (
    <Col className="checkout-delivery-adress-wrapper col-12 col-md-auto">
      <Col className="checkout-delivery-adress-title">
        <VertIcon component={HomeOutlined} />
        <VertTypography.Title>Endereço de Entrega</VertTypography.Title>
      </Col>
      <DeliveryAddressInfos
        address={combinedAddress}
        addressInvalid={addressInvalid}
        {...props}
      />
      {openModal && (
        <ModalNewDeliveryAddress
          address={editAdress}
          open={openModal}
          onStateModal={(event) => {
            setOpenModal(event);
          }}
        />
      )}
      {ynToBool(process.env.REACT_APP_HAS_WARNING_ADDRESS) && <AlertAddress/>}
    </Col>
  );
};

CheckoutDeliveryAddress.propTypes = {
  adresses: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      street: PropTypes.string,
      number: PropTypes.number,
      bourgh: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      uf: PropTypes.string,
      cep: PropTypes.string,
      complement: PropTypes.string,
      reference: PropTypes.string,
    })
  ),
  adressSelected: PropTypes.func,
  addressInvalid: PropTypes.bool,
};

export default CheckoutDeliveryAddress;
